import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation createOfferMutation($input: CreateOfferInput!) {
    createOffer(input: $input) {
      offerEdge {
        node {
          ...OfferCell_offer
          store {
            id
          }
        }
      }
      lists {
        ...OffersContainer_lists
      }
      errors {
        key
        messages
      }
    }
  }
`;

const createOffer = (environment, attributes, listsId, args = {}) => {
  const { backgroundImage, ...otherAttributes } = attributes;

  const uploadables = backgroundImage
    ? { offerBackgroundImage: backgroundImage }
    : {};

  return commit(environment, {
    mutation,
    uploadables,
    variables: {
      input: otherAttributes,
    },
    configs: [
      {
        type: 'RANGE_ADD',
        parentID: listsId,
        edgeName: 'offerEdge',
        connectionInfo: [
          {
            key: 'Offers_offers',
            rangeBehavior: 'append',
          },
        ],
      },
    ],
    ...args,
  });
};

export default createOffer;
